import { combineReducers } from 'redux';
import { carClaimDetailsReducer } from './CarClaimDetails';
import { personalAccidentClaimDetailsReducer } from './PersonalAccidentClaimDetails';
import { cancerClaimDetailsReducer } from './CancerClaimDetails';
import { corporateHealthClaimDetailsReducer } from './CorporateHealthClaimDetails';
import { healthClaimDetailsReducer } from './HealthClaimDetails';

export default combineReducers({
  carClaimDetails: carClaimDetailsReducer,
  personalAccidentClaimDetails: personalAccidentClaimDetailsReducer,
  cancerClaimDetails: cancerClaimDetailsReducer,
  corporateHealthClaimDetails: corporateHealthClaimDetailsReducer,
  healthClaimDetails: healthClaimDetailsReducer,
});
